import { all } from 'redux-saga/effects';
import getTableWatcher from '../../list-table/sagas/tablesSaga';
import userWatcher from '../../user/redux/sagas/UserSaga';
import impcWatcher from '../../impc/redux/sagas/ImpcSaga';
import doDenestImpcMappingAddWatcher
  from '../../../application/mrd-administration/impc-mapping/redux/sagas/DenestImpcMappingSagas';
import deviceInformationWatcher
  from '../../../application/mrd-administration/device-information/redux/sagas/DeviceInformationSaga';
import flightInformationWatcher
  from '../../../application/mrd-administration/flight-information/redux/sagas/FlightInformationSaga';
import handlerWatcher from '../../../application/mrd-administration/handlers/redux/sagas/HandlersSaga';
import notificationWatcher from '../../notifications/redux/sagas/NotificationSaga';
import deviceSettingsWatcher
  from '../../../application/mrd-administration/device-settings/redux/sagas/DeviceSettingsSaga';
import contactManagementWatcher
  from '../../../application/mrd-administration/contact-management/redux/sagas/ContactsSagas';
import contactWatcher from '../../../application/mrd-administration/device-information/contact-management/redux/sagas/ContactManagementSagas';
import NotificationServiceWatcher from '../../../application/mrd-administration/notification-service/redux/sagas/NotificationServiceSagas';
import translationsWatcher
  from '../../../application/mrd-administration/translations/redux/sagas/MrdAppTranslationsSagas';

function* rootSaga() {
  yield all([
    getTableWatcher(),
    userWatcher(),
    impcWatcher(),
    doDenestImpcMappingAddWatcher(),
    deviceInformationWatcher(),
    flightInformationWatcher(),
    handlerWatcher(),
    notificationWatcher(),
    deviceSettingsWatcher(),
    contactManagementWatcher(),
    contactWatcher(),
    NotificationServiceWatcher(),
    translationsWatcher(),
  ]);
}

export default rootSaga;
